import { jsx as a } from "react/jsx-runtime";
const v = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M12 2.474c5.514 0 10 3.64 10 8.116 0 1.79-.694 3.404-2.143 4.993-2.099 2.415-6.79 5.356-7.857 5.806-1.038.437-.918-.247-.87-.517l.004-.022.143-.857c.033-.255.068-.65-.033-.904-.112-.278-.555-.423-.88-.493C5.556 17.961 2 14.601 2 10.59c0-4.475 4.486-8.116 10-8.116m2.796 5.953h-.701a.195.195 0 0 0-.195.195v2.589l-2-2.697-.015-.02-.001-.001-.012-.012-.014-.013-.005-.003-.01-.007-.006-.004-.01-.006-.007-.003-.001-.001-.01-.004-.003-.002h-.003l-.008-.003h-.004l-.007-.003-.005-.001-.006-.001-.008-.002h-.01l-.01-.001h-.708a.195.195 0 0 0-.195.194v4.357a.194.194 0 0 0 .195.194h.701a.195.195 0 0 0 .195-.194v-2.587l2 2.7q.02.028.049.048l.014.01.005.002.004.002.005.003q.006 0 .01.004l.019.007a.2.2 0 0 0 .052.007h.701a.194.194 0 0 0 .195-.194V8.625a.195.195 0 0 0-.195-.195zm-4.828 0h-.702a.195.195 0 0 0-.194.195v4.357a.194.194 0 0 0 .194.194h.702a.194.194 0 0 0 .195-.194V8.625a.195.195 0 0 0-.195-.195zm-3.597 3.656h1.906v.003c.107 0 .194.087.194.194v.702a.195.195 0 0 1-.194.195H5.474a.2.2 0 0 1-.134-.055l-.005-.005a.2.2 0 0 1-.055-.135V8.625c0-.107.087-.195.195-.195h.701c.107 0 .195.088.195.195zM18.67 9.519a.195.195 0 0 0 .194-.195v-.699a.194.194 0 0 0-.194-.195h-2.803a.2.2 0 0 0-.14.061.19.19 0 0 0-.055.134v4.358c0 .05.02.098.055.134l.005.005a.2.2 0 0 0 .135.055h2.802a.195.195 0 0 0 .195-.195v-.702a.195.195 0 0 0-.195-.195h-1.906v-.736h1.906a.2.2 0 0 0 .18-.12.2.2 0 0 0 .015-.075v-.704a.195.195 0 0 0-.195-.195h-1.906V9.52z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  v as default
};
